import React from 'react'
import Image, { StaticImageData } from 'components/Image'
import { ReactChild } from 'data/types/types'
import Button from 'components/Button'
import classNames from 'classnames'

type PropTypes = {
  includePadding?: boolean
  bannerImage: string | StaticImageData
  title?: string
  subtitle?: string
  button: {
    text: ReactChild
    onClick?: () => void
    className?: string
  }
  altText?: string
  content?: string
  children?: ReactChild
}

const BannerCardFullWidthSection = ({
  includePadding = true,
  bannerImage,
  title,
  subtitle,
  button,
  altText,
  children,
}: PropTypes) => {
  return (
    <div className={`relative flex flex-col items-center justify-center ${includePadding && 'mt-75 lg:mt-[125px] lg:mb-0 mb-50'}`}>
      <div className="relative h-[399px] lg:h-[900px] w-full">
        <Image
          src={bannerImage}
          alt={altText}
          className="object-cover"
          layout="fill"
        />
      </div>
      <div className="relative w-full lg:absolute -mt-100 lg:mt-0">
        <div className="container-public">
          <div className="bg-white shadow-availability-form rounded-4 px-25 py-30 sm:px-60 sm:py-80">
            <div className="flex flex-col w-full h-full gap-20">
              <div className="mx-auto font-bold uppercase text-grey-750 text-14 leading-20 tracking-1/2 w-max">
                {subtitle}
              </div>
              <div className="text-grey-900 font-bold font-serif text-32 md:text-42 lg:text-48 tracking-title leading-title max-w-[486px] mx-auto text-center">
                {title}
              </div>
              {children}
              <Button
                variant="outline-grey"
                className={classNames(
                  'flex items-center gap-10 mx-auto mt-40 w-max',
                  button.className,
                )}
                onClick={button.onClick}
              >
                {button.text}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BannerCardFullWidthSection
